import { ChangesCard } from "@/components/agents/agent-changes";
import { createFileRoute, useLoaderData, useRouter } from "@tanstack/react-router";

/** `/agents/$slug/changes` — what the agent changed, with an undo per
 *  row. */
export const Route = createFileRoute("/_app/agents/$slug/changes")({
  component: AgentChanges,
});

function AgentChanges() {
  const data = useLoaderData({ from: "/_app/agents/$slug" });
  const router = useRouter();
  return <ChangesCard changes={data.changes ?? []} onReverted={() => void router.invalidate()} />;
}
